import React from "react";
import PlagiarismCheckerContent from "./PlagiarismCheckerContent";
import NavBar from "../NavBar";
import Footer from "../Footer";
import { analytics } from "../../App";
import { logEvent } from "firebase/analytics";
import WhyWeNeedPlagiarismChecker from "./WhyWeNeedPlagiarismChecker";
import { createContext, useState, useRef } from "react";
import PlagiarismDetectorResult from "./PlagiarismDetectorResult";

//create context
export const plagiarismContext = createContext({
  enter_ai_text: "",
  probability: 0,
  is_plagiarism: 0,
  text: "",
  isLoaded: false,
});

function PlagiarismMain() {
  //plagiarism form values
  const [plagiarismDetectorValues, setPlagiarismDetectorValues] = useState({
    enter_ai_text: "",
    probability: 0,
    is_plagiarism: 0,
    text: "",
    isLoaded: false,
  });

  //reference to detector result
  const detectorResultSectionRef = useRef(null);

  return (
    <div>
      {/*Firebase analytics */}
      {logEvent(analytics, "AI Plagiarism checker Screen")}

      {/*Add title and metadata */}
      <title>AI Plagiarism checker free</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href="https://humanizetexts.com/plagiarism-checker"
      />
      <meta
        name="description"
        content="Detect duplicate content instantly with our powerful plagiarism checker. Whether you're a student, teacher, writer, or SEO expert, our tool helps you ensure your content is 100% original and plagiarism-free. Scan essays, articles, research papers, or web content in seconds using advanced AI-powered plagiarism detection. Get detailed reports and protect your content from unintentional copying."
      ></meta>
      <meta
        name="keywords"
        content="text summarizer,text summarization,summarization tools,summarize news,summarize articles,summarize story,minify news,one click summarizer,free text summarizer,text summarizer online,artifical intelligence,summarizer ai,"
      ></meta>
      <meta property="og:title" content="AI Plagiarism checker free" />
      <meta name="twitter:title" content="AI Plagiarism checker free"></meta>

      {/* Main Content */}
      <plagiarismContext.Provider
        value={{
          plagiarismDetectorValues,
          setPlagiarismDetectorValues,
          detectorResultSectionRef,
        }}
      >
        {/* Main Content */}
        <div className="p-3">
          {/* NavBar component */}
          <NavBar />
          {/* Content */}
          <PlagiarismCheckerContent />
          {/* Detector Results*/}
          <PlagiarismDetectorResult />
          {/* Why we need Plagiarism checker */}
          <WhyWeNeedPlagiarismChecker />
          {/* Footer */}
          <Footer />
        </div>
      </plagiarismContext.Provider>
    </div>
  );
}

export default PlagiarismMain;
